"use strict";
exports.__esModule = true;
exports.ROUNDED = void 0;
exports.ROUNDED = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    '2xl': 'rounded-2xl',
    '3xl': 'rounded-3xl'
};
//# sourceMappingURL=table-container.style.js.map